import { stats } from "@/mocks/comics";

export default function Hero() {
  return (
    <section id="top" className="relative flex items-center min-h-[620px] md:min-h-[720px] overflow-hidden">
      {/* background */}
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=abstract%20vibrant%20anime%20comic%20world%20scene%2C%20dynamic%20composition%20of%20floating%20manga%20panels%20and%20comic%20splash%20effects%20in%20warm%20orange%20and%20deep%20teal%2C%20stylized%20illustration%2C%20bold%20energetic%20shapes%2C%20dark%20moody%20edges%20with%20glowing%20highlights%2C%20cinematic%20wide%20shot%2C%20digital%20artwork&width=1600&height=1000&seq=hero-zhui-2026&orientation=landscape)",
        }}
      />
      {/* dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/45 to-foreground-950/70"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/20 border border-accent-400/40 text-accent-200 text-xs md:text-sm font-medium px-4 py-1.5 mb-5">
            <i className="ri-flashlight-fill text-base" />
            更新最快 · 追更不迷路
          </span>

          <h1 className="font-heading text-4xl md:text-6xl leading-tight text-background-50">
            新话准时看
            <span className="text-accent-300"> 追更不迷路</span>
          </h1>

          <p className="mt-5 md:mt-6 text-base md:text-lg text-background-50/85 leading-relaxed max-w-2xl">
            51免费漫画网追更，热门连载漫画更新提醒，新章节第一时间推送。免费追更同步全网最新话，连载、新番、海外精品一站看齐，随时打开随时看。
          </p>

          <div className="mt-8 md:mt-9 flex flex-col sm:flex-row items-center gap-3">
            <a
              href="#today"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-medium px-7 py-3 md:px-8 md:py-3.5 transition-colors cursor-pointer"
            >
              <i className="ri-refresh-line mr-2 text-lg" />
              查看今日更新
            </a>
            <a
              href="#reminder"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 text-sm md:text-base font-medium px-7 py-3 md:px-8 md:py-3.5 transition-colors cursor-pointer"
            >
              了解追更提醒
            </a>
          </div>

          {/* stats */}
          <dl className="mt-12 md:mt-14 grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 w-full">
            {stats.map((s) => (
              <div
                key={s.label}
                className="rounded-xl bg-background-50/10 border border-background-50/15 px-4 py-4 md:py-5 text-center"
              >
                <dt className="order-2 mt-1 text-xs md:text-sm text-background-50/75">{s.label}</dt>
                <dd className="font-heading text-2xl md:text-3xl text-accent-300">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}